/* 普通搜索
queryArr: [{
    key: String            搜索的字段名
    placeholder: String    组件的placeholder属性
    type: String           组件类型，input为el-input，date为el-date-pick，select为el-select
    dateType: String       组件为el-date-pick时的type属性，不写的话默认为date
    options: Array         组件为el-select时的选项
}]
*/

/* 高级搜索
seniorArr: [{
    key: String            搜索的字段名
    label: String          搜索名称
    placeholder: String    组件的placeholder属性（默认为label）
    type: String           组件类型，input为el-input，date为el-date-pick，select为el-select
    dateType: String       组件为el-date-pick时的type属性，不写的话默认为date
    options: Array         组件为el-select时的选项
}]
*/
<script>
import { ICON_DEFAULT } from '@/constant'
export default {
    props: {
        // 标题
        title: {
            type: String,
            default: ''
        },
        // 图标
        icon: {
            type: String,
            default: ICON_DEFAULT
        },
        // 查询的数组
        queryArr: {
            type: Array,
            required: false
        },
        // 高级查询的数组
        seniorArr: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            searchObj: {}
        }
    },
    render(h) {
        let template = <section span={25} class="toolbar"></section>
        template.children = template.children || []
        if (this.title) {
            template.children.push(<i class={'fa ' + this.icon}></i>)
        }
        template.children.push(<span class="title">{this.title}</span>)
        if (this.$slots.default) {
            template.children.push(<div style="float: right">{this.$slots.default}</div>)
        }
        if (this.seniorArr.length) {
            let senior =
            <el-popover placement="bottom" trigger="click" popper-class="search-popper">
                <el-form inline label-width="90px" label-position="right" size="mini">
                    {
                        this.seniorArr.map(val => {
                            let ph = ''
                            if (val.placeholder) {
                                ph = val.placeholder
                            } else {
                                ph = (val.type === 'input' ? '请输入' : '请选择') + val.label
                            }
                            switch (val.type) {
                                case 'input':
                                    return <el-row>
                                        <el-form-item label={val.label + '：'}>
                                            <el-input clearable size="mini" placeholder={ph} v-model={this.searchObj[val.key]} suffix-icon="el-icon-search"></el-input>
                                        </el-form-item>
                                    </el-row>
                                case 'date':
                                    return <el-row>
                                        <el-form-item label={val.label + '：'}>
                                            <el-date-picker clearable size="mini" placeholder={ph} start-placeholder="开始日期" end-placeholder="结束日期"
                                                type={val.dateType ? val.dateType : 'date'} v-model={this.searchObj[val.key]} value-format="yyyy-MM-dd">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-row>
                                case 'select':
                                    return <el-row>
                                        <el-form-item label={val.label + '：'}>
                                            <el-select clearable placeholder={ph} size="mini" v-model={this.searchObj[val.key]}>
                                                {val.options.map(item => {
                                                    return <el-option label={item.label} value={item.value} key={item.value}></el-option>
                                                })}
                                            </el-select>
                                        </el-form-item>
                                    </el-row>
                                default:
                                    break
                            }
                        })
                    }
                </el-form>
                <el-button slot="reference" type="primary">高级查询</el-button>
            </el-popover>
            template.children.push(senior)
        }
        template.children.push(<el-button type="danger" on-click={this.handleClear}>清空</el-button>)
        template.children.push(<el-button type="primary" on-click={this.handleSearch}>查询</el-button>)
        this.queryArr.forEach(val => {
            switch (val.type) {
                case 'input':
                    template.children.push(<el-input clearable size="mini" placeholder={val.placeholder} v-model={this.searchObj[val.key.split(',')[0]]}
                        on-input={value => this.searchMore(value, val.key)}></el-input>)
                    break
                case 'date':
                    template.children.push(
                        <el-date-picker clearable size="mini" placeholder={val.placeholder} start-placeholder="开始日期" end-placeholder="结束日期"
                            type={val.dateType ? val.dateType : 'date'} v-model={this.searchObj[val.key]} value-format="yyyy-MM-dd">
                        </el-date-picker>
                    )
                    break
                case 'select':
                    template.children.push(
                        <el-select clearable placeholder={val.placeholder} size="mini" filterable={val.filterable} v-model={this.searchObj[val.key]}>
                            {val.options.map(item => {
                                return <el-option label={item.label} value={item.value} key={item.value}></el-option>
                            })}
                        </el-select>)
                    break
                default:
                    break
            }
        })

        return template
    },
    methods: {
        searchMore(value, params) {
            params.split(',').forEach(item => {
                this.searchObj[item] = value
            })
        },
        handleClear() {
            this.searchObj = {}
            this.$emit('sendQueryData', {})
        },
        handleSearch() {
            this.$emit('sendQueryData', this.searchObj)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/var.scss';
.el-button + .el-button {
  margin-left: 0px;
}
.title {
  //   color: #606266;
  font-weight: 600;
  color: #4a6076;
  font-size: 16px;
  line-height: 36px;
  margin-left: 2px;
}
.toolbar {
  border-bottom: 4px solid $--color-line;
  margin-bottom: 10px;
  .el-input {
    width: inherit;
    float: right;
    margin-right: 15px;
    margin-top: 3px;
  }
  .el-select {
    float: right;
    margin-right: 15px;
    margin-top: 3px;
  }
  .el-date-editor {
    float: right;
    margin-right: 15px;
    margin-top: 3px;
  }
  .el-button {
    float: right;
    margin: 3px 10px 3px 0;
  }
  .el-dropdown {
      float: right;
      margin: 3px 10px 3px 0;
  }
  .mr50 {
    margin-right: 50px !important;
  }
}

@media screen and (max-width: 1400px) {
  .toolbar {
    .el-input {
      width: 150px;
      float: right;
      margin-right: 15px;
      margin-top: 3px;
    }
    .el-select {
      width: 150px;
      float: right;
      margin-right: 15px;
      margin-top: 3px;
    }
    .el-date-editor {
      width: 150px;
      float: right;
      margin-right: 15px;
      margin-top: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CSearch.vue